import { useApiQuery } from "@/lib/query";
import { isLive } from "@/features/experiments/status";
import type { EvaluatorRun, RunsFilter } from "./types";

const POLL_MS = 3000;

/** An evaluator's runs, newest first. Polls every 3 s while any of them is still live. */
export const useEvaluatorRuns = (key: string, runner: RunsFilter) =>
  useApiQuery<EvaluatorRun[]>(
    "/evaluator-runs",
    { key, runner },
    { refetchInterval: (query) => (query.state.data?.some((r) => isLive(r.status)) ? POLL_MS : false) },
  );
